export const Hanford_2_Device_Points_Config = {
  CB_152_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'CB_152_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    dataSourceDeviceEngineeringId: 'xfmr_bu_87t2_2_487e',
    label: 'CB-152',
    points: [
      {
        label: 'Breaker Status',
        pointName: 't2_87_2_487e_in101_152_6_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  M2_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'M2_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    dataSourceDeviceEngineeringId: 'm2_751',
    label: 'M2',
    points: [
      {
        label: 'Breaker Status',
        pointName: 'm2_751_in101_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  M2_BREAKER_POINTS: {
    shape: 'breaker',
    internalId: 'M2_BREAKER_POINTS',
    dataSourceDeviceType: 'rtac',
    dataSourceDeviceEngineeringId: 'm2_52m2_751',
    label: 'M1',
    points: [
      {
        label: 'Active Power',
        pointName: 'p',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Reactive Power',
        pointName: 'q',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Power Factor',
        pointName: 'pf',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Current',
        pointName: 'i_a_1',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Voltage',
        pointName: 'v_ab',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F2_1_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'F2_1_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    label: 'F2-1',
    dataSourceDeviceEngineeringId: 'f2_1_751',
    points: [
      {
        label: 'Breaker Status',
        pointName: 'f2_1_751_in101_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  F2_1_BREAKER_POINTS: {
    shape: 'breaker',
    internalId: 'F2_1_BREAKER_POINTS',
    dataSourceDeviceType: 'rtac',
    dataSourceDeviceEngineeringId: 'f2_52f2_1_751',
    label: 'F2-1',
    points: [
      {
        label: 'Active Power',
        pointName: 'p',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Reactive Power',
        pointName: 'q',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Frequency',
        pointName: 'hz',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Current',
        pointName: 'i_a_1',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Voltage',
        pointName: 'v_ab',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  A2_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'A2_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    label: 'A2',
    dataSourceDeviceEngineeringId: 'a2_751',
    points: [
      {
        label: 'Breaker Status',
        pointName: 'a2_751_in101_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  A2_BREAKER_POINTS: {
    shape: 'breaker',
    internalId: 'A2_BREAKER_POINTS',
    dataSourceDeviceType: 'rtac',
    label: 'A2',
    dataSourceDeviceEngineeringId: 'a2_52fa2_751',
    points: [
      {
        label: 'Active Power',
        pointName: 'p',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Reactive Power',
        pointName: 'q',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Frequency',
        pointName: 'hz',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Current',
        pointName: 'i_a_1',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Voltage',
        pointName: 'v_ab',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
};
